import keyMirror from 'mattermost-redux/utils/key_mirror';

export default keyMirror({
    RECEIVED_POPULAR: null,
    RECEIVED_FEATURED: null,
    RECEIVED_NEW: null,
});
